import { useEffect, useState } from 'react';
import { API } from '@unboared/react';

export const useCurrentGameID = () => {
    const [gameID, setGameID] = useState();

    useEffect(() => {
        const unsub = API.onSharedPropertyChange((deviceID: string, key: string) => {
            if (key === 'gameID') {
                setGameID(API.getSharedProperty(deviceID, 'gameID'));
            }
        });
        return unsub;
    }, []);

    useEffect(() => {
        // Poll once at mount to grab a gameID that the screen may have broadcast
        // before our onSharedPropertyChange listener (above) was attached. Bounded:
        // if the host is on the selection menu (gameID null), don't spin forever —
        // future game launches are caught by the change listener. ~10s of retries.
        let cancelled = false;
        let attempts = 0;
        const MAX_ATTEMPTS = 50;
        const tryRead = () => {
            if (cancelled || attempts >= MAX_ATTEMPTS) return;
            attempts += 1;
            try {
                const gID = API.getSharedProperty(API.getHostID(), 'gameID');
                if (gID) {
                    setGameID(gID);
                } else {
                    setTimeout(tryRead, 200);
                }
            } catch {
                setTimeout(tryRead, 200);
            }
        };
        tryRead();
        return () => {
            cancelled = true;
        };
    }, []);

    return gameID;
};
